import { useEffect, useState } from 'react';
import { fetchMyBasics, fetchMyCollaborations, fetchMyPortfolio, fetchMySocials } from '../../lib/api';
import AppStatus from '../../components/AppStatus';
import PublicProfilePage from './PublicProfilePage';

function PreviewProfilePage({ auth }) {
  const [state, setState] = useState(null);

  useEffect(() => {
    let cancelled = false;
    Promise.all([fetchMyBasics(), fetchMySocials(), fetchMyPortfolio(), fetchMyCollaborations()])
      .then(([basics, socials, portfolio, collaborations]) => {
        if (cancelled) return;
        setState({ ...basics, socials, portfolio, collaborations });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!state) {
    return <AppStatus title="Loading preview" message="Fetching your latest profile data." />;
  }

  return <PublicProfilePage auth={auth} previewState={state} />;
}

export default PreviewProfilePage;
